import './help-me-choose-answers.scss';

import { t } from 'i18next';
import { parseAsString, useQueryState } from 'nuqs';

import { Checkbox } from '@sola/ark-core/molecules/checkbox/checkbox.js';

import { SelectionCard } from '../../../molecules/selection-card/selection-card';
import { africaImage } from '../images/africa-help-me-choose';
import { asiaImage } from '../images/asia-help-me-choose';
import { caribbeanImage } from '../images/caribbean-help-me-choose';
import { southImage } from '../images/south-help-me-choose';
import {
  africaCountries,
  asiaCountries,
  caribbeanCountries,
  southAmericaCountries,
} from '../utils/filtered-coutries';

export const regionAnswers = [
  {
    id: 'africa',
    value: africaCountries,
    image: africaImage,
  },
  {
    id: 'asia',
    value: asiaCountries,
    image: asiaImage,
  },
  {
    id: 'caribbean',
    value: caribbeanCountries,
    image: caribbeanImage,
  },
  {
    id: 'southAmerica',
    value: southAmericaCountries,
    image: southImage,
  },
];

export const HelpMeChooseRegion: React.FC = () => {
  const [location, setLocation] = useQueryState('countries', parseAsString);

  const handleCheckboxChange = (value: string, isChecked: boolean) => {
    if (isChecked) {
      setLocation(value);
    }
    if (!isChecked) {
      setLocation(null);
    }
  };

  return (
    <div className="HelpMeChooseAnswers grid grid-cols-1 sm:grid-cols-2 gap-comfy-sm lg:flex lg:flex-row justify-center">
      {regionAnswers.map((card) => (
        <Checkbox
          label={t(`help-me:regionAnswers.${card.id}`)}
          fieldClasses="Checkbox__card"
          name={card.id}
          onChange={(e) =>
            handleCheckboxChange(card.value, e.currentTarget.checked)
          }
          checked={location === card.value}
          labelContent={
            <SelectionCard
              details={{
                image: {
                  alt: t(`help-me:regionAnswers.${card.id}Alt`),
                  url: card.image,
                },
                label: t(`help-me:regionAnswers.${card.id}`),
                primaryBody: t(`help-me:regionAnswers.${card.id}`),
                secondaryTitle: t(`help-me:regionAnswers.${card.id}`),
                secondaryText: t(
                  `help-me:regionAnswers.${card.id}SecondaryText`,
                ),
                value: card.value,
              }}
              isChecked={location === card.value}
              variant="stacked"
            />
          }
        />
      ))}
    </div>
  );
};
